import { render, staticRenderFns } from "./modalConfirmRemoveDocumentV2.vue?vue&type=template&id=494ac448&scoped=true&"
import script from "./modalConfirmRemoveDocumentV2.vue?vue&type=script&lang=js&"
export * from "./modalConfirmRemoveDocumentV2.vue?vue&type=script&lang=js&"
import style0 from "./modalConfirmRemoveDocumentV2.vue?vue&type=style&index=0&id=494ac448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494ac448",
  null
  
)

export default component.exports